////////////////////////////////////////////////////////
//                      Service                       //
////////////////////////////////////////////////////////
import { useNodeCanvasStore } from '../../store';
import { Service } from '../storeClasses/service';
import { Topic } from '../storeClasses/topic';
import { Node } from '../storeClasses/node';
import {
  addDeleteButton,
  addEditButton,
  CanvasOptions,
  getCanvasCurrentPackage
} from './drawCanvas';
import { useGlobalStore } from '@/modules/globalModule/store';

export function drawService(
  stage: any,
  service: Service,
  editing: boolean = false,
  options: CanvasOptions = {}
) {
  const container: any = new createjs.Container();
  container.x = service.position.x;
  container.y = service.position.y;
  container.name = 's' + service.id;

  // Draw rectangle
  const rect = new createjs.Shape();
  rect.graphics
    .beginLinearGradientFill(['#5CC8F9', '#0B82C3'], [0, 1], 0, 0, 100, 0)
    .drawRoundRect(0, 0, service.width, service.height, service.radius);
  // rect.graphics.beginFill(service.color).drawRoundRect(0,
  //     0, service.width, service.height, service.radius
  // );
  rect.name = 'sr' + service.id;
  container.addChild(rect);

  const nameText = new createjs.Text(service.name, '20px Arial', '#000');
  nameText.x = -(nameText.getMeasuredWidth() - service.width) / 2;
  nameText.y = Math.min(nameText.getMeasuredHeight(), 10);
  nameText.name = 'st' + service.id;
  container.addChild(nameText);
  // Set text and contiainer for request
  const addServerContainer: any = new createjs.Container();
  addServerContainer.x = -(service.width - 7 - service.width) / 2;
  addServerContainer.y =
    service.height / 4 + Math.min(nameText.getMeasuredHeight(), 10);
  container.addChild(addServerContainer);
  const innerFill = new createjs.Shape();
  innerFill.graphics
    .beginFill('#9C27B0')
    .drawRoundRect(0, 0, service.width - 7, service.height / 5, 16);
  addServerContainer.addChild(innerFill);

  const serverContainerText: any = new createjs.Text(
    'Server',
    '18px Source Sans Pro',
    '#fff'
  );
  serverContainerText.set({
    textAlign: 'center',
    textBaseline: 'middle'
  });
  serverContainerText.x = addServerContainer.x + (service.width - 7) / 2;
  serverContainerText.y = addServerContainer.y + service.height / 5 / 2;
  const serverEditBtn = addEditButton(
    stage,
    container,
    service,
    -17,
    addServerContainer.y,
    's',
    { editType: 'server' }
  );
  serverContainerText.type = 'server';
  addServerContainer.type = 'server';

  container.addChild(serverContainerText);

  // Set text and container for response
  const addClientContainer: any = new createjs.Shape();
  addClientContainer.x = -(service.width - 7 - service.width) / 2;
  addClientContainer.y =
    (service.height * 2) / 4 + Math.min(nameText.getMeasuredHeight(), 10);
  addClientContainer.graphics
    .beginFill('#9C27B0')
    .drawRoundRect(0, 0, service.width - 7, service.height / 5, 16);
  container.addChild(addClientContainer);
  const clientContainerText: any = new createjs.Text(
    'Client',
    '18px Source Sans Pro',
    '#fff'
  );
  clientContainerText.set({
    textAlign: 'center',
    textBaseline: 'middle'
  });
  clientContainerText.x = addClientContainer.x + (service.width - 7) / 2;
  clientContainerText.y = addClientContainer.y + service.height / 5 / 2;
  const clientEditBtn = addEditButton(
    stage,
    container,
    service,
    service.width - 17,
    addClientContainer.y,
    's',
    { editType: 'client' }
  );
  addClientContainer.type = 'client';
  clientContainerText.type = 'client';
  container.addChild(clientContainerText);
  let mousedownCount = 0;
  // movement
  rect.on('mousedown', function (evt: any) {
    const ncStore = useNodeCanvasStore();
    ncStore.currDragOffset = {
      x: evt.stageX - container.x,
      y: evt.stageY - container.y
    };
    // If currDragOffset is identical to the drag offset in 300 ms, then we record a hold down that has taken that amount of time
    // We know that they have no pressed up if mousedownCount is not equal to 0 as mousedownCount is reset on pressup
    mousedownCount++;
    setTimeout(() => {
      const cmp1 = JSON.stringify(ncStore.currDragOffset);
      const cmp2 = JSON.stringify({
        x: evt.stageX - container.x,
        y: evt.stageY - container.y
      });
      if (cmp1 == cmp2 && mousedownCount != 0) {
        rect.dispatchEvent('dblclick');
      }
      mousedownCount = 0;
    }, 400);
  });
  rect.on('pressup', () => {
    mousedownCount = 0;
    if (options?.pressUp !== undefined) {
      options.pressUp();
      return;
    }
    const ncStore = useNodeCanvasStore();
    ncStore.dragObjId = 'undefined';
  });
  rect.on('pressmove', function (evt: any) {
    if (options?.pressMove !== undefined) {
      options.pressMove(evt);
      return;
    }
    const ncStore = useNodeCanvasStore();
    ncStore.dragObjId = service.id;
    container.x = evt.stageX - ncStore.currDragOffset.x;
    container.y = evt.stageY - ncStore.currDragOffset.y;

    ncStore.moveObj(service.id, container.x, container.y);
  });
  rect.on('dblclick', function () {
    const ncStore = useNodeCanvasStore();
    ncStore.editingService = service;
  });
  stage.on('editServiceEnd', () => {
    nameText.text = service.name;
    nameText.x = -(nameText.getMeasuredWidth() - service.width) / 2;
    nameText.y = Math.min(nameText.getMeasuredHeight(), 10);
  });
  // editing buttons
  if (options.noDelBtn === undefined) {
    const delBtn = addDeleteButton(stage, container, service, -16, -16);
    delBtn.visible = editing;
  }
  clientEditBtn.visible = serverEditBtn.visible = editing;
  if (options.noShadow === undefined) {
    rect.shadow = new createjs.Shadow('#7F7F7F', 5, 5, 1);
  }

  container.objId = service.id;
  return container;
}

export function addServices(stage: any) {
  const pkg = getCanvasCurrentPackage();
  if (!pkg) return;
  pkg.services.forEach((service) => {
    stage.addChild(drawService(stage, service));
  });
}
export function addNewService(stage: any, x: number, y: number) {
  const globalStore = useGlobalStore();
  const pkg = getCanvasCurrentPackage();
  if (!pkg) return;
  const newService = globalStore.createServiceInPkg(pkg.id, {
    x: x,
    y: y,
    name: `Service ${pkg.services.length + 1}`
  });
  stage.addChild(drawService(stage, newService, true));
}

export function removeService(stage: any, obj: Service) {
  console.log(stage.children);
  console.log(obj);
  const toRemove = stage.children.find((ea: any) => ea.objId === obj.id);
  stage.removeChild(toRemove);
  useGlobalStore().deleteElemById(obj.id);
  stage.update();
}

export function onServiceArcPressup(
  service: Service,
  other: Node | Service | Topic,
  options: any
) {
  if (other instanceof Node) {
    if (options.editType === 'server') {
      service.addServer(other);
    } else if (options.editType === 'client') {
      service.addClient(other);
    } else {
      useNodeCanvasStore().connectingServiceNode = {
        node: other,
        service: service
      };
    }
  }
}
